import Icon from '__core/modules/atoms/Icons/Icon';
import TooltipCustom from '__core/modules/atoms/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';

function OptionLabel({ icon, iconSize, label, value, tooltip, description }) {
  const content = (
    <div data-testid={`option-${value}`} style={{ alignItems: 'center', display: 'flex', gap: '8px' }}>
      {icon && <Icon color="gray-06" fontSize={iconSize || 'small'} style={{ flexShrink: 0 }} type={icon} />}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="select-customizable__option-label">{label}</div>
        {description && <div className="select-customizable__option-description">{description}</div>}
      </div>
    </div>
  );
  if (!tooltip) return content;
  return (
    <TooltipCustom title={tooltip} placement="right" variant="secondary">
      {content}
    </TooltipCustom>
  );
}

OptionLabel.propTypes = {
  icon: PropTypes.string,
  iconSize: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tooltip: PropTypes.string,
  description: PropTypes.node,
};

export default OptionLabel;
